import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import DynamicReportGenerate from "../../../components/dynamicscreens/DynamicReportGenerate";
import SearchBar from "../../../components/Search";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import {
    noInternetMsg,
    serverMsg
} from "../../../config/messageconstant";
import { ExcelReportsJson } from "../../../DynamicFormsJson/MastersJSON/excelReports";
import { stackHolderJson } from "../../../DynamicFormsJson/MastersJSON/StackHolder";
import { getStockHolerAnalytics, setStockHolerAnalytics } from "../../../Slice/StackHolder.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { downloadF } from "../../PDF/PDFDownload";

class StockHolderAnalytics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {

            },
            fromDate: "",
            toDate: "",
            stockStakeHolderId: "",
            searchValueForBillList: "",
            searchValueForOrderList: "",
            searchValueForLostOrderList: "",
            searchValueForPendingPaymentsList: "",
            dataToSet: [],
            grandTotalForBillList: 0,
            grandTotalForOrderList: 0,
            grandTotalForLostOrderList: 0,
            grandTotalForPendingPaymentsList: 0,
        };
    }
    async componentDidMount() {
        const { getStockHolerAnalytics, showLoador, showNotification } = this.props;

        if (navigator.onLine) {
            if (this.props.params.id) {

                let stockHolderDetails = JSON.parse(localStorage.getItem("stockHolderDetails"));

                this.setState({
                    dataToSet: [
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Firm Name",
                            value:
                                stockHolderDetails.firmNameWithType !== null
                                    ? stockHolderDetails.firmNameWithType
                                    : "",
                        },
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Owner Name",
                            value:
                                stockHolderDetails.ownerName !== null
                                    ? stockHolderDetails.ownerName
                                    : "",
                        },
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Order To",
                            value:
                                stockHolderDetails.orderToName !== null
                                    ? stockHolderDetails.orderToName
                                    : "",
                        },

                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Region",
                            value: stockHolderDetails.regionName !== null ? stockHolderDetails.regionName : "",
                        },
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "State",
                            value: stockHolderDetails.stateName !== null ? stockHolderDetails.stateName : "",
                        },
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Area",
                            value: stockHolderDetails.areaNames !== null ? stockHolderDetails.areaNames : "",
                        },
                    ],
                    fromDate: dayjs().format("DD-MM-YYYY"),
                    toDate: dayjs().format("DD-MM-YYYY"),
                    stockStakeHolderId: this.props.params.id,
                });

                showLoador({ loador: true });
                await getStockHolerAnalytics({
                    fromDate: dayjs().format("DD-MM-YYYY"),
                    toDate: dayjs().format("DD-MM-YYYY"),
                    stockStakeHolderId: this.props.params.id,
                }).then(({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                        let grandTotalForBillList = 0;
                        response.billList.map((dataObj) => {
                            grandTotalForBillList =
                                grandTotalForBillList + +dataObj.totalAmt;
                        });

                        let grandTotalForOrderList = 0;
                        response.orderList.map((dataObj) => {
                            grandTotalForOrderList =
                                grandTotalForOrderList + +dataObj.totalAmt;
                        });

                        let grandTotalForLostOrderList = 0;
                        response.lostOrderList.map((dataObj) => {
                            grandTotalForLostOrderList =
                                grandTotalForLostOrderList + +dataObj.totalAmt;
                        });

                        let grandTotalForPendingPaymentsList = 0;
                        response.pendingAmt.map((dataObj) => {
                            grandTotalForPendingPaymentsList =
                                grandTotalForPendingPaymentsList + +dataObj.totalAmt;
                        });

                        this.setState({
                            grandTotalForBillList,
                            grandTotalForOrderList,
                            grandTotalForLostOrderList,
                            grandTotalForPendingPaymentsList,
                        });
                    }
                });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }



    onSearchData = async (data) => {
        const { getStockHolerAnalytics, showLoador, showNotification } = this.props;

        if (navigator.onLine) {

            if (this.props.params.id) {
                this.setState({
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    stockStakeHolderId: this.props.params.id,
                })

                showLoador({ loador: true });
                await getStockHolerAnalytics({
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    stockStakeHolderId: this.props.params.id,
                }).then(({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                        let grandTotalForBillList = 0;
                        response.billList.map((dataObj) => {
                            grandTotalForBillList =
                                grandTotalForBillList + +dataObj.totalAmt;
                        });

                        let grandTotalForOrderList = 0;
                        response.orderList.map((dataObj) => {
                            grandTotalForOrderList =
                                grandTotalForOrderList + +dataObj.totalAmt;
                        });

                        let grandTotalForLostOrderList = 0;
                        response.lostOrderList.map((dataObj) => {
                            grandTotalForLostOrderList =
                                grandTotalForLostOrderList + +dataObj.totalAmt;
                        });

                        let grandTotalForPendingPaymentsList = 0;
                        response.pendingAmt.map((dataObj) => {
                            grandTotalForPendingPaymentsList =
                                grandTotalForPendingPaymentsList + +dataObj.totalAmt;
                        });

                        this.setState({
                            grandTotalForBillList,
                            grandTotalForOrderList,
                            grandTotalForLostOrderList,
                            grandTotalForPendingPaymentsList,
                        });
                    }
                });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };



    onSearchForBillList = (searchValue) => {
        this.setState({
            searchValueForBillList: searchValue,
        });
    };


    getFilteredTableDataForBillList = (targetList) => {
        const { searchValueForBillList } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["billNo"] &&
                    currentRow["billNo"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForBillList.trim().toLowerCase())) ||
                (currentRow["date"] &&
                    currentRow["date"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForBillList.trim().toLowerCase())) ||
                (currentRow["outletName"] &&
                    currentRow["outletName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForBillList.trim().toLowerCase())) ||
                (currentRow["totalAmt"] &&
                    currentRow["totalAmt"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForBillList.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };


    onSearchForOrderList = (searchValue) => {
        this.setState({
            searchValueForOrderList: searchValue,
        });
    };


    getFilteredTableDataForOrderList = (targetList) => {
        const { searchValueForOrderList } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["orderNo"] &&
                    currentRow["orderNo"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForOrderList.trim().toLowerCase())) ||
                (currentRow["date"] &&
                    currentRow["date"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForOrderList.trim().toLowerCase())) ||
                (currentRow["outletName"] &&
                    currentRow["outletName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForOrderList.trim().toLowerCase())) ||
                (currentRow["totalAmt"] &&
                    currentRow["totalAmt"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForOrderList.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };


    onSearchForLostOrderList = (searchValue) => {
        this.setState({
            searchValueForLostOrderList: searchValue,
        });
    };


    getFilteredTableDataForLostOrderList = (targetList) => {
        const { searchValueForLostOrderList } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["orderNo"] &&
                    currentRow["orderNo"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForLostOrderList.trim().toLowerCase())) ||
                (currentRow["orderDate"] &&
                    currentRow["orderDate"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForLostOrderList.trim().toLowerCase())) ||
                (currentRow["outletName"] &&
                    currentRow["outletName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForLostOrderList.trim().toLowerCase())) ||
                (currentRow["productName"] &&
                    currentRow["productName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForLostOrderList.trim().toLowerCase())) ||
                (currentRow["totalAmt"] &&
                    currentRow["totalAmt"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForLostOrderList.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };


    onSearchForPendingPaymentsList = (searchValue) => {
        this.setState({
            searchValueForPendingPaymentsList: searchValue,
        });
    };


    getFilteredTableDataForPendingPaymentsList = (targetList) => {
        const { searchValueForPendingPaymentsList } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["billNo"] &&
                    currentRow["billNo"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForPendingPaymentsList.trim().toLowerCase())) ||
                (currentRow["billDate"] &&
                    currentRow["billDate"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForPendingPaymentsList.trim().toLowerCase())) ||
                (currentRow["outletName"] &&
                    currentRow["outletName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForPendingPaymentsList.trim().toLowerCase())) ||
                (currentRow["paymentRecieptAmt"] &&
                    currentRow["paymentRecieptAmt"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForPendingPaymentsList.trim().toLowerCase())) ||
                (currentRow["paymentRecieptStatus"] &&
                    currentRow["paymentRecieptStatus"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForPendingPaymentsList.trim().toLowerCase())) ||
                (currentRow["totalAmt"] &&
                    currentRow["totalAmt"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForPendingPaymentsList.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    rowDataForExcelReports = [
        {
            isStatic: true,
            index: 1,
            reportName: "Monthly Sales Analysis Report",
            filter:
                "",
            url: "/api/distributionreport/v1//monthly-sales-analysis/by-dates-and-stock-stake-holder",
            days: 124,
        },
        {
            isStatic: true,
            index: 2,
            reportName: "Distributor Report",
            filter: "",
            url: "/api/distributionreport/v1/monthly-sale-bill-analysis/for-admin?fromDate={fromDate}&toDate={toDate}&distributorId={distributorId}",
            days: 124,
        },
        {
            isStatic: true,
            index: 3,
            reportName:
                "Product Wise Sale Register",
            filter:
                "",
            url: "/api/distributionreport/v1/report/product-sale-register?fromDate={fromDate}&toDate={toDate}",
            days: 31,
        },
        {
            isStatic: true,
            index: 4,
            reportName: "Purchase Bill",
            filter: "",
            url: "/api/distributionreport/v1/stock-stake-holder/bill-excel",
            days: 124,
        },
    ];


    getExcel = (row, rowData) => {
        const { fromDate, toDate, stockStakeHolderId } = this.state;
        const { showLoador, showNotification } = this.props;

        if (navigator.onLine) {

            if (rowData.index == 1) {
                const dataToSave = {
                    fromDate: fromDate,
                    toDate: toDate,
                    stockStakeHolderId: stockStakeHolderId,

                };

                showLoador({ loador: true });
                downloadF({
                    isGet: false,
                    url: endpoint.monthlySalesAnalysisLatest + "/by-dates-and-stock-stake-holder",
                    postBody: dataToSave,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            } else if (rowData.index == 2) {
                const dataToSave = {
                    fromDate: fromDate,
                    toDate: toDate,
                    stockStakeHolderId: stockStakeHolderId,

                };

                showLoador({ loador: true });
                downloadF({
                    isGet: true,
                    url: endpoint.monthlySalesBillAnalysis +
                        "/for-admin?fromDate=" + fromDate + "&toDate=" + toDate +
                        "&&distributorId=" + stockStakeHolderId,
                    postBody: dataToSave,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            } else if (rowData.index == 3) {
                const dataToSave = {
                    fromDate: fromDate,
                    toDate: toDate,
                    stockStakeHolderId: stockStakeHolderId,

                };

                showLoador({ loador: true });
                downloadF({
                    isGet: false,
                    url:
                        endpoint.exportDataNew +
                        "/product-wise-sale-register-for-stock-stake-holder-by-dates",
                    postBody: dataToSave,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            } else if (rowData.index == 4) {
                const dataToSave = {
                    fromDate: fromDate,
                    toDate: toDate,
                    stockStakeHolderIds: stockStakeHolderId,

                };

                showLoador({ loador: true });
                downloadF({
                    isGet: false,
                    url: endpoint.stackholderLatest + "/bill-excel",
                    postBody: dataToSave,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            }

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    render() {
        const { stockHolderList } = this.props;
        const {
            dynamicMasterData,
            searchValueForBillList,
            searchValueForOrderList,
            searchValueForLostOrderList,
            searchValueForPendingPaymentsList,
            dataToSet,
            grandTotalForBillList,
            grandTotalForOrderList,
            grandTotalForLostOrderList,
            grandTotalForPendingPaymentsList,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 2,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        DataToSet={dataToSet}
                        showBackToList={true}
                        dynamicMasterData={dynamicMasterData}
                        showTitle={true}
                        screenTitle={stackHolderJson.screenTitleForAnalytics}
                        fieldMeta={stackHolderJson.fieldMetaForAnalytics}
                        showSaveBtnMain={false}
                        showSaveNextBtn={false}
                        showSaveBtn={true}
                        saveBtnText={"Search"}
                        onSave={this.onSearchData}
                        padding={true}
                        paddingTop={true}
                    />
                    <br />
                    {Object.keys(stockHolderList?.stockHolderAnalytics).length !== 0 && (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    gap: 15,
                                    width: '100%',
                                    padding: 15,
                                    minHeight: '100vh',
                                }}
                            >
                                {/* Left Column for Tables */}
                                <div style={{
                                    flex: 3,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 15,
                                    width: "60px"
                                }}>
                                    {/* Bill List Table */}
                                    <div
                                        style={{
                                            background: 'white',
                                            padding: 5,
                                            borderRadius: 8,
                                            border: '1px #E6E6E6 solid',
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: 'white',
                                                borderRadius: 8,
                                                border: '0 #E6E6E6 solid',
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: 'white',
                                                    borderRadius: 8,
                                                    border: '0 #E6E6E6 solid',
                                                    overflow: 'scroll',
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Bill List (
                                                    {
                                                        stockHolderList?.stockHolderAnalytics?.billList.length + ", " +
                                                        grandTotalForBillList.toFixed(2)
                                                    })
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ "aria-label": "search" }}
                                                            searchValueForBillList={searchValueForBillList}
                                                            filteredRows={
                                                                this.onSearchForBillList
                                                            }
                                                        ></SearchBar>
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: '#fff' }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: '2%' }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '8%' }}>
                                                            Bill No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Date
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Outlet Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Bill Amount
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stockHolderList?.stockHolderAnalytics?.billList.length !== 0 ? (
                                                        <>
                                                            {this.getFilteredTableDataForBillList(stockHolderList?.stockHolderAnalytics?.billList)?.map(
                                                                (billDataObj, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align="center">{index + 1}</TableCell>
                                                                        <TableCell align="center">{billDataObj.billNo}</TableCell>
                                                                        <TableCell align="center">{billDataObj.date}</TableCell>
                                                                        <TableCell align="left">{billDataObj.outletName}</TableCell>
                                                                        <TableCell align="right">{billDataObj.totalAmt.toFixed(2)}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            )}
                                                        </>
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="center">
                                                                <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                    No data found
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>

                                    {/* Order List Table */}
                                    <div
                                        style={{
                                            background: 'white',
                                            padding: 5,
                                            borderRadius: 8,
                                            border: '1px #E6E6E6 solid',
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: 'white',
                                                borderRadius: 8,
                                                border: '0 #E6E6E6 solid',
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: 'white',
                                                    borderRadius: 8,
                                                    border: '0 #E6E6E6 solid',
                                                    overflow: 'scroll',
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Order List ({stockHolderList?.stockHolderAnalytics?.orderList.length
                                                        + ", " + grandTotalForOrderList.toFixed(2)})
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ 'aria-label': 'search' }}
                                                            searchValueForOrderList={searchValueForOrderList}
                                                            filteredRows={this.onSearchForOrderList}
                                                        />
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: '#fff' }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: '2%' }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '8%' }}>
                                                            Order No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Date
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Outlet Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Order Amount
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stockHolderList?.stockHolderAnalytics?.orderList.length !== 0 ? (
                                                        <>
                                                            {this.getFilteredTableDataForOrderList(stockHolderList?.stockHolderAnalytics?.orderList)?.map((billDataObj, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center">{index + 1}</TableCell>
                                                                    <TableCell align="center">{billDataObj.orderNo}</TableCell>
                                                                    <TableCell align="center">{billDataObj.date}</TableCell>
                                                                    <TableCell align="left">{billDataObj.outletName}</TableCell>
                                                                    <TableCell align="right">{billDataObj.totalAmt.toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            ))}

                                                        </>
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="center">
                                                                <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                    No data found
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>

                                    {/* Lost Orders Table */}
                                    <div
                                        style={{
                                            background: 'white',
                                            padding: 5,
                                            borderRadius: 8,
                                            border: '1px #E6E6E6 solid',
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: 'white',
                                                borderRadius: 8,
                                                border: '0 #E6E6E6 solid',
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: 'white',
                                                    borderRadius: 8,
                                                    border: '0 #E6E6E6 solid',
                                                    overflow: 'scroll',
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Lost Orders ({stockHolderList?.stockHolderAnalytics?.lostOrderList.length
                                                        + ", " + grandTotalForLostOrderList.toFixed(2)})
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ 'aria-label': 'search' }}
                                                            searchValueForLostOrderList={searchValueForLostOrderList}
                                                            filteredRows={this.onSearchForLostOrderList}
                                                        />
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: '#fff' }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: '2%' }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '10%' }}>
                                                            Order No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '8%' }}>
                                                            Date
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Outlet Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Product Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '5%' }}>
                                                            Order Amount
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stockHolderList?.stockHolderAnalytics?.lostOrderList.length !== 0 ?
                                                        (<>
                                                            {this.getFilteredTableDataForLostOrderList(stockHolderList?.stockHolderAnalytics?.lostOrderList)?.map((billDataObj, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center">{index + 1}</TableCell>
                                                                    <TableCell align="center">{billDataObj.orderNo}</TableCell>
                                                                    <TableCell align="center">{billDataObj.orderDate}</TableCell>
                                                                    <TableCell align="left">{billDataObj.outletName}</TableCell>
                                                                    <TableCell align="left">{billDataObj.productName}</TableCell>
                                                                    <TableCell align="right">{billDataObj.totalAmt.toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            ))}

                                                        </>) : (
                                                            <TableRow>
                                                                <TableCell colSpan={6} align="center">
                                                                    <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                        No data found
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>

                                    {/* Pending Payments Table */}
                                    <div
                                        style={{
                                            background: 'white',
                                            padding: 5,
                                            borderRadius: 8,
                                            border: '1px #E6E6E6 solid',
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: 'white',
                                                borderRadius: 8,
                                                border: '0 #E6E6E6 solid',
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: 'white',
                                                    borderRadius: 8,
                                                    border: '0 #E6E6E6 solid',
                                                    overflow: 'scroll',
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Pending Payments Against Bill ({stockHolderList?.stockHolderAnalytics?.pendingAmt.length
                                                        + ", " + grandTotalForPendingPaymentsList.toFixed(2)})
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ 'aria-label': 'search' }}
                                                            searchValueForBillList={searchValueForPendingPaymentsList}
                                                            filteredRows={this.onSearchForPendingPaymentsList}
                                                        />
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: '#fff' }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: '2%' }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '7%' }}>
                                                            Bill No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '7%' }}>
                                                            Bill Date
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '8%' }}>
                                                            Outlet Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '8%' }}>
                                                            Payment Receipt Amount
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '8%' }}>
                                                            Payment Receipt Status
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '8%' }}>
                                                            Total Amount
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stockHolderList?.stockHolderAnalytics?.pendingAmt.length !== 0 ?
                                                        (<>
                                                            {this.getFilteredTableDataForPendingPaymentsList(stockHolderList?.stockHolderAnalytics?.pendingAmt)?.map((billDataObj, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center">{index + 1}</TableCell>
                                                                    <TableCell align="center">{billDataObj.billNo}</TableCell>
                                                                    <TableCell align="center">{billDataObj.billDate}</TableCell>
                                                                    <TableCell align="left">{billDataObj.outletName}</TableCell>
                                                                    <TableCell align="right">{Number(billDataObj.paymentRecieptAmt).toFixed(2)}</TableCell>
                                                                    <TableCell align="center">{billDataObj.paymentRecieptStatus}</TableCell>
                                                                    <TableCell align="right">{billDataObj.totalAmt.toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </>) : (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                        No data found
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>

                                {/* Right Column for Timeline */}
                                <div style={{
                                    flex: 1,
                                    minWidth: '400px',
                                    padding: '12px'
                                }}>
                                    <div style={{
                                        position: 'sticky',
                                        top: 15,
                                        maxHeight: 'calc(100vh - 30px)',
                                        background: 'white',
                                        padding: '12px',
                                        borderRadius: 10,
                                        border: '1px solid #E6E6E6',
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}>
                                        <h4 style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                            zIndex: 10,
                                            padding: '8px 0',
                                            borderBottom: '1px solid #E6E6E6',
                                            margin: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#333',
                                        }}>
                                            Time Line
                                        </h4>
                                        <div style={{
                                            flex: 1,
                                            overflowY: 'auto',
                                            marginTop: '16px',
                                        }}>
                                            {stockHolderList?.stockHolderAnalytics?.timeLine?.map(
                                                (timeLineOj, index) => {
                                                    const itemObject = {
                                                        id: timeLineOj.id,
                                                        date: timeLineOj.date,
                                                        orderAmt: timeLineOj.orderAmt,
                                                        billAmt: timeLineOj.billAmt,
                                                    };
                                                    return (
                                                        <div key={index} style={cardStyle}>
                                                            <div style={headerStyle}>Date: {itemObject.date}</div>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                padding: '8px',
                                                                gap: '16px',
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <div style={dataSectionStyle}>
                                                                    <span style={{
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        color: '#2c3e50'
                                                                    }}>
                                                                        {itemObject.orderAmt.toFixed(2)}
                                                                    </span>
                                                                    <span style={{
                                                                        fontSize: '13px',
                                                                        fontWeight: '500',
                                                                        color: '#666'
                                                                    }}>
                                                                        Order Amount
                                                                    </span>
                                                                </div>
                                                                <div style={dataSectionStyle}>
                                                                    <span style={{
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        color: '#2c3e50'
                                                                    }}>
                                                                        {itemObject.billAmt.toFixed(2)}
                                                                    </span>
                                                                    <span style={{
                                                                        fontSize: '13px',
                                                                        fontWeight: '500',
                                                                        color: '#666'
                                                                    }}>
                                                                        Bill Amount
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <DynamicReportGenerate
                                maxDateValid={true}
                                getExcel={this.getExcel}
                                screenTitle={ExcelReportsJson.screenTitle}
                                fieldMeta={[]}
                                buttonCenter={ExcelReportsJson.buttonCenter}
                                dynamicMasterData={dynamicMasterData}
                                searchButton={false}
                                PDFButton={false}
                                EXCELButton={false}
                                baseIdColumn={ExcelReportsJson.baseIdColumn}
                                apiBaseURL={ExcelReportsJson.apiBaseURL}
                                marginTop={false}
                                openNewTab={true}
                                rowData={this.rowDataForExcelReports}
                                hideNoteAndResetButton={true}
                            />
                        </>
                    )}
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    stockHolderList: state.stackholder,
    targetList: state.target,
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getStockHolerAnalytics,
    setStockHolerAnalytics,

};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(StockHolderAnalytics);


const cardStyle = {
    background: '#fff',
    borderRadius: '10px',
    border: '1px solid #E6E6E6',
    marginBottom: '16px',
    overflow: 'hidden',
    padding: '8px',
    width: '100%',
    maxWidth: '350px',
    minHeight: '100px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
};

const headerStyle = {
    background: '#f8f8f8',
    padding: '8px',
    fontSize: '14px',
    fontWeight: '600',
    borderBottom: '1px solid #E6E6E6',
    borderRadius: '6px 6px 0 0',
    color: '#333',
};

const dataSectionStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    padding: '8px',
    gap: '4px',
};

